import React from 'react'
import { useState, useEffect } from 'react'
import ArticleList from './Components/ArticleList'
import ProgressCircle from './Components/ProgressCircle';
import Navbar from './Components/Navbar';
import SortBy from './Components/SortBy';
import Checkboxes from './Components/Checkbox';
import './Hero.css'

function Hero(props) {

    const [recievedArticles, setRecievedArticles] = useState([]);
    const [showLoading, setShowLoading] = useState('');
    const [debouncedText, setDebouncedText] = useState(props.searchText);
    const [fetchError, setFetchError] = useState(true);

    const [searchPreference, setSearchPreference] = useState('relevance')
    const [language, setLanguage] = React.useState('Any');


    useEffect(() => {

        const timerId = setTimeout(() => {
            setDebouncedText(props.searchText)
        }, 700);


        return () => {
            clearTimeout(timerId);
        }
    }, [props.searchText])

    useEffect(() => {

        // const getApiData = 
        // fetch(`https://newsapi.org/v2/everything?q=${debouncedText ? debouncedText : 'Apple'}&pageSize=10&sortBy=${searchPreference}&apiKey=dbd041b08abc498aaa2392c000effc84`)
        fetch(`https://gnews.io/api/v4/search?q=${debouncedText ? debouncedText : 'Apple'}&token=9db03bc76e99b73f0782f7e5d09a812a&sortby=${searchPreference}&lang=${language}`)
            .then((response) => response.json())
            .then((data) => {
                setShowLoading('a')
                setRecievedArticles(data.articles)
            })
            .catch((e) => {
                console.log('yoyoyo' + e)
                setFetchError(false)
            })

    }, [debouncedText, searchPreference, language])


    const handleChange = (event) => {
        setLanguage(event.target.value);
    };




    return (

        <div>
            {
                fetchError ?
                    (
                        showLoading ?
                            <>
                                <Navbar handleLogout={props.handleLogout} onSearchChange={props.onSearchChange} />

                                <div className="sort-checkbox-container" >
                                    <div className="sort">
                                        <SortBy style={{ width: '70%', backgroundColor: 'yellow' }} searchPreference={searchPreference} setSearchPreference={setSearchPreference} />
                                    </div>

                                    <div className="checkbox" >
                                        <Checkboxes language={language} handleChange={handleChange} />
                                    </div>
                                </div>
                                <ArticleList recievedArticles={recievedArticles} />
                            </>
                            :
                            <ProgressCircle />
                    )
                    : (
                        <div style={{ position: 'absolute', width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }} >
                            <h3> !Oops <br />
                                Sorry no internet connection seems to be available</h3>
                        </div>
                    )

            }

        </div>
    )
}

export default Hero;












// import React from 'react'
// import Navbar from './Navbar';

// function Hero({ handleLogout, onSearchChange }) {
//     return (
//         <div>
//             <Navbar handleLogout={handleLogout} onSearchChange={onSearchChange} />
//             <h2>Welcome Hero bro </h2>
//         </div>
//     )
// }

// export default Hero;
